import React from "react";
import classNames from "classnames";
import Portal from "components/Portal";

/**
 * Modal
 * - Needs to be in a Portal in order to always be at the bottom of the DOM (to avoid z-index issues)
 * @param props
 */
export default function Modal(props: {
  children?: React.ReactNode;
  active?: boolean;
  closeable?: string;
  image?: boolean;
  fullsize?: boolean;
  className?: string;
  onClose?: () => void;
}) {
  let {
    active = false,
    closeable = true,
    image = false,
    fullsize = false,
    className = "",
    onClose,
  } = props;

  function closeModal() {
    return onClose && onClose();
  }

  const classes = classNames("modal", {
    "is-active": active,
    "is-fullsize": fullsize,
    [className]: className.length,
  });

  const modalContentClass = classNames("modal-content", {
    box: image,
  });

  return active ? (
    <Portal>
      <div className={classes}>
        <div className="modal-background" onClick={closeModal}></div>

        <div className={modalContentClass}>
          {props.children}

          {closeable && (
            <button
              className="modal-close is-large"
              aria-label="close"
              onClick={closeModal}
            ></button>
          )}
        </div>
      </div>
    </Portal>
  ) : (
    <></>
  );
}
